/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 64:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = __webpack_require__(29);
var _extends = __webpack_require__(213);
/* eslint-disable react/forbid-prop-types */
/**
 * Module dependencies
 */
var React = __webpack_require__(689);
var _require = __webpack_require__(308),
  Switch = _require.Switch,
  Route = _require.Route;
var EMPTY_ARRAY = [];
var EMPTY_OBJECT = {};

/**
 * Routes Compoent - render switch with pages
 */
var Routes = function Routes(_ref) {
  var location = _ref.location,
    _ref$routes = _ref.routes,
    routes = _ref$routes === void 0 ? EMPTY_ARRAY : _ref$routes,
    _ref$extraProps = _ref.extraProps,
    extraProps = _ref$extraProps === void 0 ? EMPTY_OBJECT : _ref$extraProps;
  return routes && routes.length > 0 && /*#__PURE__*/_jsx(Switch, {
    location: location
  }, void 0, routes.map(function (route, i) {
    return /*#__PURE__*/_jsx(Route, {
      path: route.path,
      exact: route.exact,
      render: function render(props) {
        return /*#__PURE__*/React.createElement(route.component, _extends({}, props, extraProps, {
          route: route
        }));
      }
    }, route.key || i);
  }));
};
module.exports = Routes;

/***/ }),

/***/ 213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 29:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 308:
/***/ ((module) => {

"use strict";
module.exports = require("react-router");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(64);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=Routes.js.map